import React, { useState, useContext } from 'react';
import styled from 'styled-components'
import Input from '../../../../../components/input'
import Button from '../../../../../components/button'
import EmailIcon from '@material-ui/icons/Email';
import { createTicket } from '../../../../../api'
import { AuthContext } from '../../../../../auth-context'
import { DashboardContext } from '../../../dashboard-context'

const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 100%;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`;

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`;

const Description = styled.p`
  color: #5a5a5a;
  font-size: 1.125rem;
  margin-bottom: 32px;
  
  span {
    font-family: ${props => props.theme.font.primary};
  }
`;

const TextBoxLabel = styled.label`
  color: #676767;
  display: block;
  font-family: ${props => props.theme.font.primary};
  margin-bottom: 8px;
`;

const TextBox = styled.textarea`
  border: 1px solid ${props => props.error ? '#F44336' : '#DDDEE8'};
  border-radius: 4px;
  color: #5a5a5a;
  font-family: ${props => props.theme.font.primary};
  font-size: 1.25rem;
  font-weight: 300;
  margin-bottom: 16px;
  min-height: 330px;
  padding: 12px;
  transition: 0.2s ease border, 0.2s ease box-shadow;
  width: 100%;

  &:hover {
    border: 1px solid ${props => props.error ? '#F44336' : ' #1890ff'};
  }

  &:focus {
    border: 1px solid ${props => props.error ? '#F44336' : ' #1890ff'};
    box-shadow: 0px 0px 0px 3px ${props => props.error ? '#FFBBB6D1' : ' #b1dfffa6'};
    outline: none;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  @media(max-width: 900px) {
    margin-top: 16px;
  }
`;

const AddButton = styled(Button)`
  margin: 0;
  margin-left: 16px;
  min-width: 180px;
`;

const AccountsTable = (props) => {
  const { user } = useContext(AuthContext);
  const { openSnackbar } = useContext(DashboardContext);
  const [email, updateEmail] = useState(user.email_address)
  const [message, updateMessage] = useState('')
  const [subject, updateSubject] = useState('')

  const emailIsValid = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const handleSubmit = () => {
    if(subject && message) {
      if(emailIsValid(email)) {
        createTicket(user.full_name, user.email_address, `[PORTAL] ${subject}`, message)
        setTimeout(() => {
          updateSubject('');
          updateMessage('');
          openSnackbar('Your message has been sent.', false)
        }, 1500);
      } else {
        openSnackbar('Please use a valid email.', true)
      }
    } else {
      openSnackbar('Please fill in all fields.', true)
    }
  }



  return (
    <React.Fragment>
      <Container className={props.className}>
        <Label>
          <EmailIcon /> Contact Us
        </Label>
        <Description>
          If you have questions regarding your portal account, please fill out the form below and we will get back to you as soon as possible.
        </Description>
        <Input
          label="Email"
          type="email" 
          autoComplete="email" 
          value={email}
          onChange={updateEmail}
          disabled={true}
        />
        <Input
          label="Subject"
          value={subject}
          onChange={updateSubject}
        />
        <TextBoxLabel htmlFor=''>Message</TextBoxLabel>
        <TextBox 
          value={message}
          onChange={(e) => updateMessage(e.target.value)}
        />
        <ButtonContainer>
          <AddButton 
            label="Send"
            onClick={() => handleSubmit()}
          />
        </ButtonContainer>
      </Container>
  </React.Fragment>
  )
}

export default AccountsTable